/**
 * Substitutes `{fieldName}` placeholders in a provider type's
 * `displayNameTemplate` with values from the current connection config.
 *
 * Returns `null` when any referenced placeholder field is unset, empty
 * string, or empty array — caller should treat that as "no suggestion"
 * and fall back to the provider type's static `displayName`.
 */
export function resolveDisplayNameTemplate(
    template: string,
    config: Record<string, unknown>,
): string | null {
    let allFilled = true;
    const resolved = template.replace(/\{([a-zA-Z][a-zA-Z0-9_]*)\}/g, (_, name: string) => {
        const v = config[name];
        if (v === undefined || v === null || v === '' || (Array.isArray(v) && v.length === 0)) {
            allFilled = false;
            return '';
        }
        return String(v);
    });
    return allFilled ? resolved : null;
}
